import Http from '../Http';
import { LARAVEL_BACKEND_API_URL } from '../Helper';

export const generateInspectionGuide = async (wpRequestId, requestData, projectId) => {
  try {
    const response = await Http.post(`${LARAVEL_BACKEND_API_URL}v1/inspection-guides`, {
      wp_request_id: wpRequestId,
      request_data: requestData,
      project_id: projectId
    });
    return response.data;
  } catch (error) {
    console.error("Error generating AI guide:", error);
    throw error;
  }
};

export const getInspectionGuide = async (wpRequestId) => {
  try {
    const response = await Http.get(`${LARAVEL_BACKEND_API_URL}v1/inspection-guides?wp_request_id=${wpRequestId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching AI guide:", error);
    throw error;
  }
};

export const generateReportDraft = async (reportId, inspectionData, requestData, factualOnly = false) => {
  try {
    const response = await Http.post(`${LARAVEL_BACKEND_API_URL}v1/reports/${reportId}/drafts`, {
        inspection_data: inspectionData,
        request_data: requestData,
        factual_only: factualOnly
    });
    return response.data;
  } catch (error) {
    console.error("Error generating AI draft:", error);
    throw error;
  }
};

export const getReportDraft = async (reportId) => {
    try {
      const response = await Http.get(`${LARAVEL_BACKEND_API_URL}v1/reports/${reportId}/drafts`);
      return response.data;
    } catch (error) {
      console.error("Error fetching AI drafts:", error);
      throw error;
    }
  };

export const markDraftAsReviewed = async (reportId, draftId) => {
  try {
    const response = await Http.post(`${LARAVEL_BACKEND_API_URL}v1/reports/${reportId}/drafts/${draftId}/review`);
    return response.data;
  } catch (error) {
    console.error("Error reviewing AI draft:", error);
    throw error;
  }
};
